import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static values = { hasQueryParameters: Boolean }

  declare hasQueryParametersValue: boolean

  declare localStorageKey: string

  connect(): void {
    this.localStorageKey = 'via_tableFilterBoxPinned_' + document.location.pathname
    const storedFlag = window.localStorage.getItem(this.localStorageKey)
    const expandableBox = this.element.querySelector('details')

    if (storedFlag === 'true' || this.hasQueryParametersValue) {
      if (expandableBox !== undefined && expandableBox !== null) {
        expandableBox.setAttribute('open', '')
      }
    }

    expandableBox?.addEventListener('toggle', () => {
      const method = expandableBox.hasAttribute('open') ? 'expanded' : 'contracted'
      this[method]()
    })
  }

  expanded(): void {
    window.localStorage.setItem(this.localStorageKey, 'true')
  }

  contracted(): void {
    window.localStorage.removeItem(this.localStorageKey)
  }
}
